module.exports = __webpack_public_path__ + "img/login.de440013.svg";